import { useQuery } from '@tanstack/react-query';
import { cpFetch } from '@/lib/cpClient';

export interface DiscoveredAgent {
  agent_id?: string;
  id?: string;
  name?: string;
  description?: string;
  domain?: string;
  agent_type?: string;
  version?: string;
}

export function useAgentDiscover() {
  return useQuery({
    queryKey: ['agents', 'discover'],
    queryFn: async () => {
      const res = await cpFetch<{ agents?: DiscoveredAgent[] }>('/api/agents/discover');
      return res?.agents ?? [];
    },
    staleTime: 60_000,
  });
}
